/**
 *
 * DropdownSelector index file.
 *
 */

import DropdownSelector from "./DropdownSelector";

export default DropdownSelector;
